import api from "../../../../api";
import urls from "../../../../urls";

export async function generate2FaCode(method: string) {
  await api.post<void>(urls.auth.generate2FaCode(), {
    method
  });
}
